"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const utils_1 = require("src/utils/utils");
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const sharedUtils_1 = require("src/utils/sharedUtils");
const reduxHooks_1 = require("src/hooks/reduxHooks");
const thunk_1 = require("src/stores/exportedStore/clients/thunk");
const selectors_1 = require("src/stores/exportedStore/clients/selectors");
const selectors_2 = require("src/stores/applicationStore/auth/selectors");
const actions_1 = require("src/stores/exportedStore/clients/actions");
const InfoCard_1 = __importDefault(require("src/components/molecules/InfoCard"));
const EmptyBlock_1 = __importDefault(require("src/components/molecules/EmptyBlock"));
const ClientHeader_1 = __importDefault(require("./ClientHeader"));
const ClientStat_1 = __importDefault(require("./ClientStat"));
const client_module_css_1 = __importDefault(require("./styles/client.module.css"));
const TextOrLink_1 = __importDefault(require("src/components/molecules/TextOrLink"));
const Client = () => {
    const { user_id } = (0, react_router_dom_1.useParams)();
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const client = (0, reduxHooks_1.useAppSelector)(selectors_1.selectClient);
    const stat = (0, reduxHooks_1.useAppSelector)(selectors_1.selectClientStatTourView);
    const me = (0, reduxHooks_1.useAppSelector)(selectors_2.selectUser);
    const [notFound, setNotFound] = (0, react_1.useState)(false);
    const [viewStat] = (0, react_1.useMemo)(() => {
        return [(0, sharedUtils_1.access)({ profile: me, section: "statistics", permission: "view" })];
    }, [me]);
    const fillInfoContent = (client) => {
        const obj = {
            [i18n_1.default.t("Created")]: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, utils_1.humanizeDate)(client.created) }),
            [i18n_1.default.t("Entered")]: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, utils_1.humanizeDate)(client.last_visit) }),
            [i18n_1.default.t("tariff_expire")]: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: client.tariff_expire ? (0, utils_1.humanizeDate)(client.tariff_expire) : "—" }),
            [i18n_1.default.t("First pay")]: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: client.tariff_expire ? (0, utils_1.humanizeDate)(client.tariff_first_pay) : "—" }),
        };
        if (client.last_params) {
            const keys = Object.keys(client.last_params);
            keys.forEach((key) => {
                const text = client.last_params[key] || i18n_1.default.t("Empty");
                obj[key] = (0, jsx_runtime_1.jsx)(TextOrLink_1.default, { text: text, field: key });
            });
        }
        return obj;
    };
    (0, react_1.useEffect)(() => {
        dispatch((0, thunk_1.fetchClientThunk)(user_id, setNotFound));
        if (viewStat)
            dispatch((0, thunk_1.fetchClientStatTourViewThunk)(user_id));
    }, [user_id]);
    (0, react_1.useEffect)(() => {
        return () => {
            dispatch((0, actions_1.setClientClear)());
        };
    }, []);
    if (notFound) {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: client_module_css_1.default.container }, { children: [(0, jsx_runtime_1.jsx)(ClientHeader_1.default, { client: client }), (0, jsx_runtime_1.jsx)("div", { children: i18n_1.default.t("User not found") })] })));
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: client_module_css_1.default.container }, { children: [(0, jsx_runtime_1.jsx)(ClientHeader_1.default, { client: client }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: client_module_css_1.default.info }, { children: !!client ? ((0, jsx_runtime_1.jsx)(InfoCard_1.default, { content: fillInfoContent(client), title: i18n_1.default.t("Users properties") })) : ((0, jsx_runtime_1.jsx)(EmptyBlock_1.default, { title: i18n_1.default.t("Loading") })) })), !!viewStat && (0, jsx_runtime_1.jsx)(ClientStat_1.default, { data: stat })] })));
};
exports.default = Client;
